export default __webpack_public_path__ + "static/media/smallMockup11.51fdae18.jpg";